<script lang="ts">
  import type { SupplierRawInvoice } from "../../helpers/types";
  import Text from "../Text.svelte";

  export let row: SupplierRawInvoice;

  const STATUS_MAP: Record<string, string> = {
    ["parse_failure"]: "processing failed",
    ["new"]: "processing",
  };

  const BACKGROUND_COLOR_MAP: Record<string, string> = {
    ["parse_failure"]: "error-low",
    ["new"]: "warning-low",
  };

  const TEXT_COLOR_MAP: Record<string, string> = {
    ["parse_failure"]: "error-light",
    ["new"]: "warning-light",
  };
</script>

<div class="container">
  <div class="pill" style="background-color: var(--rekki-{BACKGROUND_COLOR_MAP[row.status]});">
    <Text color={TEXT_COLOR_MAP[row.status]} ocd>{STATUS_MAP[row.status]}</Text>
  </div>
</div>

<style>
  .container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .pill {
    padding: 8px 10px;
    border-radius: 100px;
  }
</style>
